const state = () => ({
  infoModalText: "",
  infoModalVisible: false
});

const mutations = {
  openInfoModal(state) {
    state.infoModalVisible = true;
  },
  closeInfoModal(state) {
    state.infoModalVisible = false;
  },
  setInfoModalText(state, val) {
    state.infoModalText = val;
  }
};

export default {
  namespaced: true,
  state,
  mutations
};
